import { render, staticRenderFns } from "./veStuAssocCharge.vue?vue&type=template&id=48d627b2&scoped=true"
import script from "./veStuAssocCharge.vue?vue&type=script&lang=js"
export * from "./veStuAssocCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d627b2",
  null
  
)

export default component.exports